import { Injectable, Injector, NgZone } from '@angular/core';
import { PublishableDisplayableItemsViewModel } from '../../../../../shared/components/displayable-content/displayable-item-list/publishable-displayable-items-view-model';
import { TemplateDomainModel } from '../../../../../../domainModels/template-domain-model';
import { PrintTemplatesContainerViewModel } from '../print-templates-container/print-templates-container-view-model';
import { NavigationService } from '../../../../../../services/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuType } from '../../../../../../models/utils/dto/menu-type-definition';

@Injectable()
export class PrintReportTemplatesViewModel extends PublishableDisplayableItemsViewModel {
  constructor(
    protected templateDomainModel: TemplateDomainModel,
    // printTemplatesContainerViewModel provided by the Logged In Scope - need to get access to which tag is selected,
    // only way to pass this data to child is via a shared model, because child component is being created
    // by tab bar component (inflated in non conventional way), which means I can't pass in inputs
    protected printTemplatesContainerViewModel: PrintTemplatesContainerViewModel,
    navigationService: NavigationService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(printTemplatesContainerViewModel, navigationService, ngZone, ngbModal, injector);
    this.setupFilter();
  }

  protected defaultEmptyStateTitle = 'No Print Report Templates';

  protected override defaultEmptyStateDescription = 'Create a report template by using the button above.';

  protected itemsToFilter$ = this.templateDomainModel.printReportMenuTemplates$;

  protected getEmptyStateTitleCopy(menuTypeFilter: string): string {
    return this.genericEmptyStateTitleCopyForTemplates(menuTypeFilter, 'print report templates');
  }

  openCreatePrintTemplateModal() {
    this.openCreateTemplateModal(MenuType.PrintReportMenu);
  }
}
